const $deliveryAddress = $('.js-delivery-address');
const $check = $('.js-delivery-address-check');

const deliveryAddress = {
  initialize() {
    if ($deliveryAddress.length) {
      this.createEvents();
      this.check();
    }
  },

  createEvents() {
    $check.on('change', () => {
      this.check();
    });
  },

  check() {
    const isChecked = $check[0].checked;
    $deliveryAddress.toggle(isChecked);
    $deliveryAddress.find('[data-required]').prop('required', isChecked);
  },
};

export default deliveryAddress;
